'use strict';

/**
 * @ngdoc function
 * @name thothAppApp.controller:UserServiceCtrl
 * @description
 * # UserCtrl
 * Controller of the thothAppApp
 */
angular.module('thothApp.services')
  .factory('User', ['$http', 'domain', 'BaseService', 'toaster', function ($http, domain, BaseService, toaster) {
    var BASE_USER_URL = domain.name + '/api/v1/users/';
    var baseService = new BaseService();

    baseService.initialize({
      baseUrl: BASE_USER_URL,
      baseModelName: 'user'
    });

    baseService.save_cloud_token = function(params) {
      return $http.post(BASE_USER_URL + 'save_cloud_token', params);
    };

    baseService.error = function(error) {
      if(error && error.status === 422 && error.data && error.data.error) {  
        toaster.pop('error', 'Empleado inactivo', error.data.error.inactive);
      }
      if(error && error.status === 422) {  
        if('email' in error.data.errors) {
          toaster.pop('error', 'Email', 'El email ' + error.data.errors.email);
        }
        if('password' in error.data.errors) {
          toaster.pop('error', 'Contraseña', 'La contraseña ' + error.data.errors.password);
        }
        if('password_confirmation' in error.data.errors) {
          toaster.pop('error', 'Contraseña', 'La contraseña ' + error.data.errors.password_confirmation);
        } 
      }
      baseService.baseError(error);
    };

    return baseService;
  }]);
